import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {insightsTabInitialState} from './insightsTab.consts';
import {
  AvailableDimension,
  AvailableMetricWithTotal,
  InsightsTabState,
  MeasuredPeriod,
} from './insightsTab.types';
import {Dashboard, DashboardWidget} from 'common/src/modules/dashboards/dashboards.types';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';

const insightsTabSlice = createSlice({
  name: BreadcrumbName.CampaignInsights,
  initialState: insightsTabInitialState,
  reducers: {
    _unload: () => insightsTabInitialState,
    updateInsightsTab: (_, action: PayloadAction<InsightsTabState>) => {
      return action.payload;
    },
    updateMeasuredPeriod: (state, action: PayloadAction<Partial<MeasuredPeriod>>) => {
      state.measuredPeriod = {...state.measuredPeriod, ...action.payload};
    },
    updateAvailableMetricsWithTotals: (
      state,
      action: PayloadAction<AvailableMetricWithTotal[]>,
    ) => {
      state.availableMetricsWithTotals = action.payload;
    },
    updateAvailableDimensions: (state, action: PayloadAction<AvailableDimension[]>) => {
      state.availableDimensions = action.payload;
    },
    updateDashboards: (state, action: PayloadAction<Dashboard[]>) => {
      state.dashboards = action.payload;
    },
    updateWidgets: (state, action: PayloadAction<DashboardWidget[]>) => {
      state.widgets = action.payload;
    },
  },
});

const {
  _unload,
  updateInsightsTab,
  updateMeasuredPeriod,
  updateAvailableMetricsWithTotals,
  updateAvailableDimensions,
  updateDashboards,
  updateWidgets,
} = insightsTabSlice.actions;

export {
  _unload,
  updateInsightsTab,
  updateMeasuredPeriod,
  updateAvailableMetricsWithTotals,
  updateAvailableDimensions,
  updateDashboards,
  updateWidgets,
};

export default insightsTabSlice.reducer;
